import { ADMIN_SEARCH_BASE_URL } from '../constants';

export const goToAdminAdvancedSearch = (queryTerm: string) => {
  const queryParams = { query: queryTerm };
  const search = new URLSearchParams(queryParams).toString();
  const url = queryTerm ? `${ADMIN_SEARCH_BASE_URL}?${search}` : ADMIN_SEARCH_BASE_URL;
  window.location.assign(url);
};
